/* Timantti header: hover-to-open mega menu (desktop) and mobile drawer Shop / Info tabs */
(() => {
  const hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
  // Short grace period so the panel doesn't close while the pointer crosses the gap below the menu item
  const CLOSE_DELAY = 150;

  const setOpen = (details, open) => {
    details.open = open;
    details.querySelector('summary')?.setAttribute('aria-expanded', open);
  };

  function initMegaHover(root) {
    root.querySelectorAll('[data-tt-mega-hover="true"]').forEach((nav) => {
      nav.querySelectorAll('header-menu').forEach((menu) => {
        if (menu.dataset.ttHover) return;
        menu.dataset.ttHover = 'true';
        const details = menu.querySelector('details');
        let closeTimer;

        menu.addEventListener('mouseenter', () => {
          if (!hoverQuery.matches) return;
          clearTimeout(closeTimer);
          nav.querySelectorAll('details[open]').forEach((other) => {
            if (other !== details) setOpen(other, false);
          });
          if (!details.open) setOpen(details, true);
        });

        menu.addEventListener('mouseleave', () => {
          if (!hoverQuery.matches) return;
          closeTimer = setTimeout(() => setOpen(details, false), CLOSE_DELAY);
        });
      });
    });
  }

  function initDrawerTabs(root) {
    root.querySelectorAll('[data-tt-drawer-tabs]').forEach((tablist) => {
      if (tablist.dataset.ttReady) return;
      tablist.dataset.ttReady = 'true';
      const tabs = [...tablist.querySelectorAll('[role="tab"]')];

      const select = (tab) => {
        tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', active);
          t.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
      };

      // Capture on the tablist and stop propagation: Dawn's MenuDrawer binds every drawer button
      // to "close the nearest <details>", which for these tabs is the whole drawer
      tablist.addEventListener(
        'click',
        (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab) return;
          event.stopPropagation();
          select(tab);
        },
        true
      );

      tabs.forEach((tab, i) => {
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          const next = tabs[(i + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(next);
          next.focus();
        });
      });
    });
  }

  const init = (root) => {
    initMegaHover(root);
    initDrawerTabs(root);
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
